import {
  CalendarViewWeekFilled,
  EventAvailableFilled,
  EventUpcomingFilled,
} from "@clockwise/icons";
import { noop } from "lodash";
import React from "react";
import { Badge, ContentContainer, ContentRow, EducationModal } from "../education-modal";

const PrimaryContent = (
  <ContentContainer>
    <ContentRow>
      <EventAvailableFilled className="cw-text-busy cw-w-4 cw-h-4" />
      <div className="cw-text-13 cw-leading-5">
        Finds availability across <span className="cw-font-semibold">attendees' meeting hours</span>{" "}
        and timezones, even for non-users of Clockwise
      </div>
    </ContentRow>
    <ContentRow>
      <CalendarViewWeekFilled className="cw-text-busy cw-w-4 cw-h-4" />
      <div className="cw-text-13 cw-leading-5">
        Clockwise will try to find a slot that's close to the{" "}
        <span className="cw-font-semibold">event's current time</span>
      </div>
    </ContentRow>
    <ContentRow>
      <EventUpcomingFilled className="cw-text-busy cw-w-4 cw-h-4" />
      <div className="cw-text-13 cw-leading-5">
        No edit permissions? Let Clockwise{" "}
        <span className="cw-font-semibold">propose the best time</span> to the meeting organizer
      </div>
    </ContentRow>
  </ContentContainer>
);

const SecondaryContent = (
  <ContentContainer>
    <ContentRow>
      <Badge>1</Badge> <div className="cw-text-13 cw-leading-5">Select a meeting </div>
    </ContentRow>
    <ContentRow>
      <Badge>2</Badge>
      <div className="cw-text-13 cw-leading-5">
        Choose a time that works best for you and your attendees
      </div>
    </ContentRow>
    <ContentRow>
      <Badge>3</Badge>
      <div className="cw-text-13 cw-leading-5">Confirm the move and you're done!</div>
    </ContentRow>
    <div className="cw-text-13 cw-leading-5">
      {/* TODO: Add click handler to correct page */}
      Want to learn more?{" "}
      <span className="cw-text-positive-muted cw-font-semibold cw-cursor-pointer" onClick={noop}>
        Talk to a CSM
      </span>{" "}
      about best practices and using Clockwise with your team.
    </div>
  </ContentContainer>
);

export const NUXReschedulingModal = ({
  onClose,
  onClickAction,
}: {
  onClose: () => void;
  onClickAction: () => void;
}) => {
  return (
    <EducationModal
      header="Quick rescheduling"
      subheader="Get multiple rescheduling suggestions for your events with a single click"
      primaryButtonText="Try it out!"
      mainContent={PrimaryContent}
      isOpen={true}
      onClose={onClose}
      onClickPrimaryButton={onClickAction}
      videoLink=""
      secondaryContent={SecondaryContent}
    />
  );
};
